import * as LJS from "../../../lib/littlejs.esm";
import { tilesize } from '../../const/tiles.ts';
import Actionable from "./actionable.ts";
const closedTileIndex = 0;
const openedTileIndex = 2;
/*
 * Door block the way if closed, and allow you to pass through if opened
 */
class Door extends Actionable {
    constructor(pos) {
        super(pos, closedTileIndex);
        // Overridden by the child class to make the actionable interactive
        this.key = "KeyE";
        this.state = "closed";
        this.setCollision(true, true, false, true);
        this.mass = 0; // Not affected by gravity
    }
    action() {
        console.log("Action triggered on Door");
        if (this.state == "closed") {
            this.state = "open";
            this.setCollision(false, false, false, false);
            this.tileInfo = LJS.tile(openedTileIndex, tilesize);
        }
        else {
            this.state = "closed";
            this.setCollision(true, true, false, true);
            this.tileInfo = LJS.tile(closedTileIndex, tilesize);
        }
    }
}
export default Door;
